import React from 'react';
import PropTypes from 'prop-types';
import SectionHeading from '../../SectionHeading/SectionHeading';
import RadioGroup from '../../RadioGroup/RadioGroup';
import PlanUtils from '../../../services/PlanService';
import './Selection.scss';
// import towel from './towel2x.svg';
// import waves from './waves.svg';
import PlanSummaryContainer from '../../../redux/containers/PlanSummaryContainer';

// const isSummer = () => {
//   const now = new Date();
//   const month = now.getMonth();
//   return month >= 11 || month < 2;
// };

// const decoration = (offer, discount) => {
//   let src = waves;
//   let style = '';
//   if (offer.enabled || discount.enabled || isSummer()) {
//     src = towel;
//     style = 'offer-image';
//   }
//   return (<img className={style} src={src} role="presentation" />);
// };

const Selection = (props) => {
  const {
    isContractSelected, setContractSelected,
    modemPrice,
    connectionPrice, shippingPrice, term, offer,
    discountWithSubscription, discount, giftWithPurchase, isByoModemSelected,
    byoModemDiscountPrice, selectedPlan, withMobileDiscount
  } = props;

  const credit = PlanUtils.getCredit(false);
  const contractRadios = () => [
    {
      id: 'no-contract-plan',
      label: 'No pesky term contract',
      value: false,
      modemPrice,
      connectionPrice,
      credit,
      offer,
      discount,
      discountWithSubscription,
      shippingPrice,
      giftWithPurchase,
      isByoModemSelected,
      byoModemDiscountPrice,
      selectedPlan,
      withMobileDiscount
    },
    {
      id: 'contract-plan',
      label: `${term} contract`,
      value: true,
      modemPrice,
      connectionPrice,
      offer,
      discountWithSubscription,
      shippingPrice,
      giftWithPurchase,
      isByoModemSelected,
      byoModemDiscountPrice,
      selectedPlan,
      withMobileDiscount
    }
  ];

  return (
    <div>
      <div className="contract-selection">
        <div className="container plan-selection">
          <div className="row">
            <div className="col-lg-8">
              <SectionHeading
                number={4}
                title={'Choose your contract type'}
                description={'Choose between no contract or a 12-month contract'}
                titleClassName={'selection-section-title'}
                numberClassName={'selection-heading-number'}
              />
              <RadioGroup
                vertical={false}
                name={'contract'}
                radioButtons={contractRadios()}
                selectedValue={isContractSelected}
                onChange={setContractSelected}
              />
            </div>
            <div className="col-sm-12 col-lg-4 contract-selection-summery-desktop">
              <PlanSummaryContainer />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="plan-selection contract-selection-summery-mobile" >
          <PlanSummaryContainer />
        </div>
      </div>
    </div>
  );
};

Selection.propTypes = {
  isContractSelected: PropTypes.bool,
  modemPrice: PropTypes.number,
  connectionPrice: PropTypes.number,
  shippingPrice: PropTypes.number,
  setContractSelected: PropTypes.func,
  term: PropTypes.string,
  offer: PropTypes.object,
  discount: PropTypes.object,
  discountWithSubscription: PropTypes.object,
  giftWithPurchase: PropTypes.object,
  isByoModemSelected: PropTypes.bool,
  byoModemDiscountPrice: PropTypes.number,
  selectedPlan: PropTypes.object,
  withMobileDiscount: PropTypes.bool,
};

export default Selection;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/Selection/Selection.js
 **/